<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Home</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" *ngIf="user$ && userMetadata">
  <ion-card color="primary">
    <!--ion-card-header>
      <ion-card-title><ion-icon name="alert-circle-outline"></ion-icon> Szia, !</ion-card-title>
      <ion-card-subtitle>Nincs elvégzendő feladat!</ion-card-subtitle>
    </ion-card-header-->
    <ion-card-content>
      <div class="row" style="display:flex;margin:auto">
            <ion-avatar class="avatar col-6 online1" style="text-align: center;border: 3px solid #dedede;">
              <img *ngIf="user$.attributes?.picture" [src]="user$.attributes.picture" [alt]="userMetadata.viselt_ker" />
              <img *ngIf="!user$.attributes?.picture" [src]="environment.avatars+'/api/?name='+userMetadata.viselt_vez+' '+userMetadata.viselt_ker+'&rounded=true&size=512&background=random'" [alt]="userMetadata.viselt_ker" />
            </ion-avatar>
            <span class="col-6" style="float:left;font-size:xx-large">Hi, {{userMetadata.viselt_vez+' '+userMetadata.viselt_ker}}!</span>
            </div>
    </ion-card-content>
  </ion-card>
</ion-content>
